<script lang="ts">
    import {onMount} from "svelte";
    import {isLoggedIn, session, userProfile} from 'src/services/auth'
    import {navigate} from "src/global/navigate";
    import TwoFactor from 'src/components/cabinet/two-factor/TwoFactor.svelte'
    import ConfirmIP from 'src/components/cabinet/confirm-ip/ConfirmIP.svelte'
    import Ban from 'src/components/cabinet/ban/Ban.svelte'

    let mounted = false
    export let redirectUnAuth: string

    onMount(() => {
        mounted = true
    })

    $: if (mounted) {
        if (!$isLoggedIn) {
            navigate(redirectUnAuth)
        }
    }
</script>

{#if !$isLoggedIn}
    <!-- svelte может выдавать ошибки при вложенных if else -->
{:else if $userProfile?.isBanned}
    <Ban/>
{:else if $session?.isNeed2fa}
    <TwoFactor/>
{:else if $session?.isNeedCode}
    <ConfirmIP/>
{:else}
    <slot></slot>
{/if}
